const {enabled}=require('./transition.js');

document.querySelectorAll('[data-client-slider]').forEach(element=>{
 const button=element.querySelector('[data-clients-pause]');
 const label=element.querySelector('[data-clients-pause-label]');
 const tracks=[...element.querySelectorAll('[data-client-track]')];
 if(!button||!tracks.length)return;
 let visible=false,paused=false;
 tracks.forEach(track=>{
  const group=track.querySelector('[data-client-group]');
  if(!group)return;
  const clone=group.cloneNode(true);
  clone.removeAttribute('data-client-group');
  clone.removeAttribute('aria-label');
  // Keep visual copies clickable, but out of the accessibility tree and Tab order.
  clone.setAttribute('aria-hidden','true');
  clone.querySelectorAll('a').forEach(link=>link.setAttribute('tabindex','-1'));
  track.append(clone);
 });
 element.classList.add('is-enhanced');button.hidden=false;
 const measure=()=>tracks.forEach(track=>{
  const group=track.querySelector('[data-client-group]');
  track.style.setProperty('--lane-duration',`${Math.max(30,group.getBoundingClientRect().width/28)}s`);
 });
 const update=()=>{
  const motion=enabled();
  element.classList.toggle('is-static',!motion);
  element.setAttribute('data-clients-running',String(motion&&visible&&!paused&&!document.hidden));
  button.setAttribute('aria-pressed',String(paused));
  label.textContent=paused?'Logo-Bewegung aktivieren':'Logo-Bewegung pausieren';
  button.querySelector('i').textContent=paused?'▷':'Ⅱ';
  button.hidden=!motion;
  measure();
 };
 button.addEventListener('click',()=>{paused=!paused;update();});
 element.addEventListener('focusin',event=>{
  const lane=event.target.closest('[data-client-lane]');
  // Reset the animated coordinate space before the browser reveals a focused link.
  if(lane&&event.target.closest('[data-client-group]')){
   element.classList.add('is-static');
   element.setAttribute('data-clients-running','false');
  }
 });
 element.addEventListener('focusout',event=>{if(!element.contains(event.relatedTarget))update();});
 new IntersectionObserver(entries=>{visible=entries.some(entry=>entry.isIntersecting);update();},{rootMargin:'100px'}).observe(element);
 if(typeof ResizeObserver!=='undefined')new ResizeObserver(measure).observe(element);
 addEventListener('onestep:motion',update);
 document.addEventListener('visibilitychange',update);
 update();
});
